import React from 'react'
import PropTypes from 'prop-types'
import { styles, Icon } from '@elparking/components'
import styled from 'styled-components'

const Container = styled.span`
    display: inline-flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    height: ${({ size }) => size};
    width: ${({ size }) => size};
    ${styles.background}
    ${styles.borderRadius}
    ${styles.borderColor}
    ${styles.borderWidth}
    ${styles.borderStyle}
`
Container.defaultProps = {
    background: 'main',
    borderRadius: '50%',
    size: '30px',
}

const IconRounded = ({
    background,
    size,
    borderRadius,
    borderColor,
    borderWidth,
    borderStyle,
    ...props }) => <Container
      background={background}
      size={size}
      borderRadius={borderRadius}
      borderColor={borderColor}
      borderWidth={borderWidth}
      borderStyle={borderStyle}
><Icon {...props} /></Container>

IconRounded.propTypes = {
    background: PropTypes.any,
    size: PropTypes.string,
    borderRadius: PropTypes.any,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.string,
    borderStyle: PropTypes.string,
}

export default IconRounded
